export default function originrequests(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                originrequest: action.originrequest,
            }
        default:
            return state;
    }
}
